'use client';

import { ReactNode, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Cookies from 'js-cookie';
import { useLazyGetProfileQuery } from '@/redux/auth/auth.api';
import { selectAccessToken, selectUserInfo } from '@/redux/auth/auth.selector';
import { logout } from '@/redux/auth/auth.slice';
import { refreshSession } from '@/redux/api.slice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useBookmarksTour } from '@/hooks/use-bookmarks-tour';
import { isProtectedRoute, shouldRestoreSession } from '@/lib/auth/session';

type GlobalWrapperProps = {
  children: ReactNode;
};

export default function GlobalWrapper({ children }: GlobalWrapperProps) {
  const accessToken = useAppSelector(selectAccessToken);
  const { email } = useAppSelector(selectUserInfo);
  const [getProfile] = useLazyGetProfileQuery({});
  const dispatch = useAppDispatch();
  const router = useRouter();

  useBookmarksTour();

  useEffect(() => {
    if (
      !shouldRestoreSession(
        Cookies.get('accessTokenUser'),
        Cookies.get('refreshTokenUser')
      )
    ) {
      return;
    }

    void refreshSession({ dispatch }).then((outcome) => {
      if (outcome !== 'rejected') return;
      dispatch(logout());
      const { pathname, search } = window.location;
      if (isProtectedRoute(pathname)) {
        router.replace(
          `/login?redirect=${encodeURIComponent(`${pathname}${search}`)}`
        );
      }
    });
  }, [dispatch, router]);

  useEffect(() => {
    if (accessToken && !email) {
      getProfile({});
    }
  }, [accessToken, email, getProfile]);

  return <>{children}</>;
}
